
import { Component, Vue } from 'nuxt-property-decorator'
import type { MetaInfo } from 'vue-meta'
import Partners from '~/components/sections/Partners.vue'
import { OnMounted, WithHead } from '~/core/vue.types'
import MembersItem from '~/components/sections/team/MembersItem.vue'
import PhoneNumberLink from '~/components/snippets/PhoneNumberLink.vue'
import SaveRouteMixin from '~/mixins/save-route.mixin'
import { teamMembersConfigAboutUs } from '~/core/config/team-members-config'
import { useSEOMetaComposer } from '~/composables/seo.composable'

@Component({
  nuxtI18n: {
    paths: {
      en: '/about-us/',
      de: '/ueber-uns/',
      fr: '/a-propos/',
    },
  },

  components: {
    MembersItem,
    Partners,
    PhoneNumberLink,
  },
  mixins: [SaveRouteMixin],
})
export default class AboutUsPage extends Vue implements WithHead, OnMounted {
  private teamMembers = teamMembersConfigAboutUs

  head (): MetaInfo {
    return useSEOMetaComposer(
      this,
      {
        title: this.$t('head.meta.aboutUs.title').toString(),
        description: this.$t('head.meta.aboutUs.description').toString(),
        route: { name: 'about-us' },
      },
    )
  }

  mounted () {
    this.$analytics.GTM.sendPageViewEvent({
      routeName: this.$route.name as string,
      pageTitle: this.$metaInfo.title || '',
      fullPath: this.$route.fullPath,
      fromPath: this.$nuxt.context.from ? this.$nuxt.context.from.fullPath : '',
      contentGroup: 'About us',
    })
  }
}
